import { render, staticRenderFns } from "./TfootRibbonBalances.vue?vue&type=template&id=cbfe70d2"
import script from "./TfootRibbonBalances.vue?vue&type=script&lang=js"
export * from "./TfootRibbonBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports